import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import {
  RdsBadgeComponent,
  RdsCellDefDirective,
  RdsCellDirective,
  RdsColumnDefDirective,
  RdsHeaderCellDefDirective,
  RdsHeaderCellDirective,
  RdsHeaderRowComponent,
  RdsHeaderRowDefDirective,
  RdsPaginatorComponent,
  RdsRowComponent,
  RdsRowDefDirective,
  RdsSortDirective,
  RdsSortHeaderComponent,
  RdsTableComponent,
  RdsTableDataSource,
  Sort,
} from '@rds/angular-components';
import { RdsPaginatorPageEvent } from '@rds/core';

import {
  DEFAULT_PAGINATION_STATE,
  EventDateTimePipe,
  RoomBookingModel,
  TablePaginationState,
  ViewportService,
} from '@bookly/shared';

import { BookingCardComponent } from '../booking-card/booking-card.component';

@Component({
  selector: 'bad-room-bookings-table',
  templateUrl: './room-bookings-table.component.html',
  styleUrls: ['./room-bookings-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    EventDateTimePipe,
    RdsTableComponent,
    RdsSortDirective,
    RdsHeaderCellDirective,
    RdsColumnDefDirective,
    RdsSortHeaderComponent,
    RdsHeaderCellDefDirective,
    RdsCellDirective,
    RdsCellDefDirective,
    RdsBadgeComponent,
    RdsHeaderRowComponent,
    RdsHeaderRowDefDirective,
    RdsRowComponent,
    RdsRowDefDirective,
    DatePipe,
    RdsPaginatorComponent,
    BookingCardComponent,
  ],
})
export class RoomBookingsTableComponent {
  @Input() public set roomBooking(value: RoomBookingModel[] | null) {
    if (value) {
      this.dataSource.data = value;
    }
  }
  @Input() public paginationState: TablePaginationState =
    DEFAULT_PAGINATION_STATE;

  @Output() public rowClicked = new EventEmitter<RoomBookingModel>();
  @Output() public pageChanged = new EventEmitter<RdsPaginatorPageEvent>();
  @Output() public sortChanged = new EventEmitter<Sort>();

  /** Below 1024px the table is replaced by a stacked card list. */
  protected readonly isCompact = inject(ViewportService).isCompact;

  protected readonly dataSource = new RdsTableDataSource<RoomBookingModel>(
    []
  ).init();

  protected readonly displayedColumns: (
    | keyof RoomBookingModel
    | 'multiselect'
  )[] = [
    'id',
    'roomDescription',
    'status',
    'startTime',
    'requester',
    'services',
  ];

  /** Space activates the card like a button, without scrolling the page. */
  protected onCardSpace(event: Event, rowData: RoomBookingModel) {
    event.preventDefault();
    this.clickRowHandler(rowData);
  }

  protected clickRowHandler(rowData: RoomBookingModel) {
    this.rowClicked.emit(rowData);
  }

  protected onPageChange(event: RdsPaginatorPageEvent) {
    this.pageChanged.emit(event);
  }

  protected onSortChange(event: Sort) {
    this.sortChanged.emit(event);
  }
}
